<template>
  <div class="rundgang">
    <Navigation />
    <div
      class="content-container mp-container"
      v-if="!modalState"
    >
        <div
          class="main"
        >
          <Plan />
        </div>
        <div
          class="aside-right"
        >
          <DetailList />
        </div>
    </div>
    <Modal v-if="modalState" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import Plan from '@/components/Plan-rundgang'
import DetailList from '@/components/Detail-list'
import Modal from '@/components/Modal'
import Navigation from '@/components/Navigation'

export default {
  name: 'rundgang',
  components: {
    Plan,
    DetailList,
    Modal,
    Navigation
  },
  data () {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      selectedRoom: 'getSelectedRoom',
      player: 'getPlayerStatus',
      pagesData: 'getPagesData',
      modalState: 'getModalState'
    })
  },
  created () {
    this.$store.state.selectedVideo = null
  }
}
</script>
<style lang="scss" scoped>
  @import '@/scss/custom.scss';
  .rundgang {
    position: relative;
    padding-top: 6rem;
  }
  .content-container {
    display: grid;
    grid-template-columns: 1fr auto;
    align-content: space-between;
  }
  .main {
    margin: 2rem 6rem 2rem 4rem
  }
</style>